import React, { Component } from 'react';
import { APP_CONST } from '../../constants';
import { Utils } from '../../services';

class GeckoAlert extends Component {

    prepareClass() {
        return APP_CONST.ALERT_CLASSES[this.props.type || APP_CONST.ALERT_TYPE_INFO];
    }

    getSizeClasses() {
        const size = this.props.size || 'default';
        
        const sizeMap = {
            'default': {
                padding: 'px-4 py-3',
                fontSize: 'text-xs',
                iconSize: '[&>svg]:size-4'
            },
            'lg': {
                padding: 'p-4',
                fontSize: 'text-sm',
                iconSize: '[&>svg]:size-5'
            }
        };

        const sizeConfig = sizeMap[size] || sizeMap['default'];
        
        return `${sizeConfig.padding} ${sizeConfig.fontSize} ${sizeConfig.iconSize}`;
    }

	renderClass() {
		const baseClasses = 'relative w-full rounded-sm border font-medium mb-4 [&>svg]:translate-y-0.5 [&>svg]:text-current';
		const sizeClasses = this.getSizeClasses();
		return Utils.classNames(
			'gecko-alert',
			baseClasses,
			sizeClasses,
			this.prepareClass(),
			this.props.className
		);
	}

    render() {
		return (
            <div role="alert" className={this.renderClass()}>

                {this.props.children}

            </div>
        );
    }
}

GeckoAlert.defaultProps = {
    className: '',
    size: 'default',
}

export default GeckoAlert;
